import _ from "lodash";
import modelBase from '../../models/model-base.model';
import { apiStatusCodes } from '../../config/global-variables';

var trainModel = {

    submitTrainingRequest: function (successCallBack, failureCallBack, projectId) {
        var params = {};

        var path = '/api/objectdetection/projects/' + projectId + '/submittrainrequest';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    getTrainingRequestsList: function (successCallBack, failureCallBack, searchStatus, pageIndex, pageSize) {
        var path = '/api/objectdetection/trainingrequests' + '?SearchStatus='+ searchStatus + '&PageIndex=' + pageIndex + '&PageSize=' + pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    approveTrainingRequest: function (successCallBack, failureCallBack, trainingRequestId) {
        var params = {};

        var path = '/api/objectdetection/trainingrequests/' + trainingRequestId + '/approve';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    cancelTrainingRequest: function (successCallBack, failureCallBack, trainingRequestId) {
        var params = {};

        var path = '/api/objectdetection/trainingrequests/' + trainingRequestId + '/cancel';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    rejectTrainingRequest: function (successCallBack, failureCallBack, trainingRequestId, reason) {
        var params = {};
        params.reason = reason.trim();

        if (params.reason.length == 0) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a reason why this training request needs to be rejected." });
            
            failureCallBack(error);

            return;
        }

        var path = '/api/objectdetection/trainingrequests/' + trainingRequestId + '/reject';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    getIterationsList : function (successCallBack, failureCallBack, projectId, pageIndex, pageSize) {
        var path = '/api/objectdetection/projects/' + projectId + '/iterations' + '?PageIndex=' + pageIndex + '&PageSize=' + pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    publishIteration: function (successCallBack, failureCallBack, projectId, iterationId) {
        var path = '/api/objectdetection/projects/' + projectId + '/iterations/' + iterationId + '/publish';
        modelBase.post(successCallBack, failureCallBack, path, {});
    },

    unpublishIteration: function (successCallBack, failureCallBack, projectId, iterationId) {
        var path = '/api/objectdetection/projects/' + projectId + '/iterations/' + iterationId + '/unpublish';
        modelBase.post(successCallBack, failureCallBack, path, {});
    },

    getTrainingSubmissionsList: function (successCallBack, failureCallBack, filter) {
        var path = '/api/objectdetection/trainingsubmission' + 
            '?FromDate='+ filter.fromDate + 
            '&ToDate=' + filter.toDate + 
            '&SearchStatus=' + filter.searchStatus +
            '&ProjectId=' + filter.searchProjectId +
            '&PageIndex=' + filter.pageIndex + 
            '&PageSize=' + filter.pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    getIterationImagesList: function (successCallBack, failureCallBack, projectId, iterationId, pageIndex, pageSize) {
        var path = '/api/objectdetection/projects/' + projectId + '/iterations/' + iterationId + '/images' + '?PageIndex=' + pageIndex + '&PageSize=' + pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    getIterationImage: function (successCallBack, failureCallBack, projectId, iterationId, imageId) {
        var path = '/api/objectdetection/projects/' + projectId + '/iterations/' + iterationId +'/images/' +  imageId;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    getPerformanceRecordsList: function (successCallBack, failureCallBack, filter) {
        var path = '/api/objectdetection/performances' + 
            '?FromDate='+ filter.fromDate + 
            '&ToDate=' + filter.toDate + 
            '&SearchStatus=' + filter.searchStatus +
            '&FromScore=' + filter.fromScore +
            '&ToScore=' + filter.toScore +
            '&ProjectId=' + filter.searchProjectId +
            '&PageIndex=' + filter.pageIndex + 
            '&PageSize=' + filter.pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    updateScore: function (successCallBack, failureCallBack, predictionId, score) {
        var params = {};
        params.score = score;

        if (Number.isNaN(params.score) || !_.isNumber(params.score)) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter only a number for the score." });
            
            failureCallBack(error);

            return;
        }

        if (params.score < 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a positive number for the score." });
            
            failureCallBack(error);

            return;
        } 

        if (params.score > 100) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a valid number for the score because its highest value is 100." });
            
            failureCallBack(error);

            return;
        }

        var path = '/api/objectdetection/performances/' + predictionId + '/updatescore';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    getPredictionDisplay: function (successCallBack, failureCallBack, predictionId) {
        var path = '/api/objectdetection/performances/' + predictionId + '/display';
        modelBase.get(successCallBack, failureCallBack, path, {});
    },
}




export default trainModel
